import { useMemo } from 'react';
import { useBreeze } from '../contexts/BreezeContext';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { useGTKMDomainSubmit } from './useGTKMDomainSubmit';
import { getGtkmAnimationState } from '../store/gtkm/selector';
import { useSelector } from 'react-redux';
import { GtkmAnimationState } from '../store/gtkm/types';
export const useAICompanyDomainSubmit = ({
  submit,
  isStepDataValid
}) => {
  const {
    submitWithRetry,
    hasBreezeEndpointBeenFetched,
    showLoadingState,
    shouldUseBreezeCompanyInfo
  } = useBreeze();
  const animationState = useSelector(state => getGtkmAnimationState(state));
  const {
    isAssignedToSpecificVariant: isAssignedToACQ173Variant
  } = useExperiment(ExperimentKeys.ACQ0173, TrackWhen.never);
  const {
    isAssignedToSpecificVariant: isAssignedToACQ177Variant
  } = useExperiment(ExperimentKeys.ACQ0177, TrackWhen.never);
  const isAssignedToACQ173VariantA = isAssignedToACQ173Variant(ExperimentParameterGroup.Variant_A);
  const isAssignedToACQ173VariantC = isAssignedToACQ173Variant(ExperimentParameterGroup.Variant_C);
  const {
    isAssignedToSpecificVariant: isAssignedToACQ175Variant
  } = useExperiment(ExperimentKeys.ACQ0175, TrackWhen.never);
  const isAssignedToACQ175VariantA = isAssignedToACQ175Variant(ExperimentParameterGroup.Variant_A);
  const isAssignedToACQ177VariantA = isAssignedToACQ177Variant(ExperimentParameterGroup.Variant_A);
  const isAssignedToGTKM = isAssignedToACQ173VariantA || isAssignedToACQ173VariantC || isAssignedToACQ177VariantA;
  const {
    handleSubmit: handleGTKMDomainSubmit,
    handleSubmitACQ175: handleGTKMDomainSubmitACQ175
  } = useGTKMDomainSubmit();
  const onSubmit = () => {
    if (isAssignedToGTKM) {
      handleGTKMDomainSubmit();
    } else if (isAssignedToACQ175VariantA) {
      handleGTKMDomainSubmitACQ175();
    } else if (shouldUseBreezeCompanyInfo) {
      submitWithRetry(submit);
    } else {
      submit();
    }
  };
  const isNextButtonEnabled = useMemo(() => {
    if (!isStepDataValid) {
      return false;
    }
    if (isAssignedToGTKM || isAssignedToACQ175VariantA) {
      return animationState !== GtkmAnimationState.Started;
    }
    if (shouldUseBreezeCompanyInfo) {
      return hasBreezeEndpointBeenFetched && !showLoadingState;
    }
    return undefined;
  }, [isStepDataValid, isAssignedToGTKM, isAssignedToACQ175VariantA, shouldUseBreezeCompanyInfo, animationState, hasBreezeEndpointBeenFetched, showLoadingState]);
  return {
    aiCompanyDomainSubmit: onSubmit,
    isAiCompanyDomainSubmitEnabled: isNextButtonEnabled
  };
};